import { MetadataFieldRendererProps } from '@/asset/components/metadata/field-renderer';
import { TimePicker } from '@mui/x-date-pickers-pro';
import { DateTime } from 'luxon';
import { FieldValues, useFormContext, useWatch } from 'react-hook-form';

/**
 * Renders a time field in the metadata form.
 *
 * IMPORTANT: This component must be wrapped in a FormProvider from react-hook-form.
 */
export function TimeFieldRenderer(props: MetadataFieldRendererProps) {
  const { metadata, setValue, error, fieldIndex } = props;
  const { control } = useFormContext<FieldValues>();
  const value = useWatch({
    control,
    name: `metadata.${fieldIndex}.value`,
  });
  return (
    <TimePicker
      label={metadata.field.label}
      value={value ? DateTime.fromFormat(String(value), 'HH:mm:ss') : null}
      onChange={(newValue: DateTime | null) => {
        const formattedValue = newValue ? newValue.toFormat('HH:mm:ss') : null;
        setValue(formattedValue);
      }}
      slotProps={{
        textField: {
          fullWidth: true,
          size: 'small',
          error: !!error,
          helperText: error?.message,
        },
        actionBar: {
          actions: ['clear', 'accept'],
        },
      }}
    />
  );
}
